<template>
    <div>
        <div v-if="loading" style="min-height: 350px; display: flex; justify-content: center; align-items: center;">
            <img src="/public/img/loading-bar.gif" />
        </div>
        <div v-else class="u-mt-20" style="padding: 20px 12px;">
            <h4>Materiais da turma</h4>
            <p style="color:#909399;">Materiais publicados pelo professor/coordenador para <strong>{{ $store.state.user.turma_nome }}</strong>.</p>

            <el-table :data="materiais" stripe style="width: 100%;" empty-text="Nenhum material publicado até o momento.">
                <el-table-column label="Tipo" width="90">
                    <template slot-scope="scope">
                        <el-tag size="mini" :type="tagTipo(scope.row.tipo)">{{ rotuloTipo(scope.row.tipo) }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="Título" min-width="220">
                    <template slot-scope="scope">
                        <strong>{{ scope.row.titulo }}</strong>
                        <div v-if="scope.row.descricao" style="color:#909399; font-size:12px;">{{ scope.row.descricao }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="Disciplina" width="150">
                    <template slot-scope="scope">
                        <span v-if="scope.row.disciplina" style="color:#409eff; font-weight:600; font-size:12px;">{{ scope.row.disciplina.nome_area }}</span>
                        <span v-else style="color:#c0c4cc;">—</span>
                    </template>
                </el-table-column>
                <el-table-column label="Prazo" width="140">
                    <template slot-scope="scope">
                        <span v-if="scope.row.data_limite" style="color:#e6a23c; font-size:12px;">{{ scope.row.data_limite | formatarDt }}</span>
                        <span v-else style="color:#c0c4cc;">—</span>
                    </template>
                </el-table-column>
                <el-table-column label="Ações" width="130" align="center">
                    <template slot-scope="scope">
                        <el-tooltip v-if="scope.row.tipo === 1 && scope.row.tem_arquivo" content="Baixar arquivo" placement="top">
                            <el-button type="primary" size="mini" circle icon="el-icon-download" :loading="baixandoId === scope.row.id" @click="baixar(scope.row)"></el-button>
                        </el-tooltip>
                        <el-tooltip v-if="scope.row.tipo === 2 || scope.row.tipo === 3" :content="scope.row.tipo === 2 ? 'Assistir' : 'Abrir link'" placement="top">
                            <el-button type="success" size="mini" circle icon="el-icon-video-play" @click="abrirVideo(scope.row)"></el-button>
                        </el-tooltip>
                        <el-tooltip v-if="scope.row.requer_retorno && permissoes.enviar_material" content="Enviar devolução" placement="top">
                            <el-button type="warning" size="mini" circle icon="el-icon-upload" @click="abrirEnvio(scope.row)"></el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>

            <!-- Modal vídeo / link -->
            <el-dialog title="" :visible.sync="modalVideoVisivel" width="720px">
                <div v-if="materialAtivo">
                    <h3>{{ materialAtivo.titulo }}</h3>
                    <p v-if="materialAtivo.descricao" style="color:#606266;">{{ materialAtivo.descricao }}</p>
                    <div v-if="materialAtivo.tipo === 2">
                        <!-- vídeo: aceita URL simples ou código de incorporação -->
                        <div v-if="ehEmbed(materialAtivo.url_video)" v-html="materialAtivo.url_video" style="text-align:center;"></div>
                        <iframe v-else-if="urlYoutube(materialAtivo.url_video)" :src="urlYoutube(materialAtivo.url_video)"
                                width="100%" height="400" frameborder="0" allowfullscreen></iframe>
                        <video v-else controls style="width:100%; max-height:420px;">
                            <source :src="materialAtivo.url_video" />
                        </video>
                    </div>
                    <div v-if="materialAtivo.tipo === 3">
                        <p>Link externo:</p>
                        <a :href="materialAtivo.url_video" target="_blank" style="word-break: break-all;">{{ materialAtivo.url_video }}</a>
                    </div>
                </div>
            </el-dialog>

            <!-- Modal enviar devolução -->
            <el-dialog title="Enviar devolução" :visible.sync="modalEnvioVisivel" width="540px">
                <div v-if="materialAtivo">
                    <p><strong>{{ materialAtivo.titulo }}</strong></p>
                    <p v-if="materialAtivo.retorno_aluno" style="color:#e6a23c;">
                        <i class="el-icon-warning"></i> Você já enviou uma devolução em
                        {{ materialAtivo.retorno_aluno.data_envio | formatarDt }}. Enviar novamente substituirá o anterior.
                    </p>
                </div>
                <el-form label-position="top">
                    <el-form-item label="Arquivo">
                        <el-upload
                            :action="`${baseUrl()}/api/portal/material/upload-arquivo`"
                            name="arquivo"
                            :headers="{ Authorization: token() }"
                            :on-success="onUploadSuccess"
                            :before-upload="beforeUpload"
                            :limit="1">
                            <el-button type="primary" icon="el-icon-upload">SELECIONAR</el-button>
                            <div v-if="retornoForm.caminho_nome" style="margin-top:4pt; color:#67c23a;">
                                <i class="el-icon-document"></i> {{ retornoForm.caminho_nome }}
                            </div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="Comentário (opcional)">
                        <el-input type="textarea" v-model="retornoForm.comentario" :rows="3"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer">
                    <el-button @click="modalEnvioVisivel = false">CANCELAR</el-button>
                    <el-button type="primary" @click="confirmarEnvio">ENVIAR</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
export default {
    filters: { formatarDt (v) { return v ? moment(v).format('DD/MM/YYYY HH:mm') : '' } },
    data () {
        return {
            loading: true,
            materiais: [],
            materialAtivo: null,
            modalVideoVisivel: false,
            modalEnvioVisivel: false,
            baixandoId: null,
            retornoForm: { caminho: '', caminho_nome: '', caminho_mime: '', caminho_size: null, comentario: '' }
        }
    },
    computed: {
        permissoes () { return this.$store.getters.permissoes }
    },
    mounted () {
        if (!localStorage.getItem('pa85726549Token')) {
            this.$router.push('/')
            return
        }
        this.load()
    },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        token () { return JSON.parse(localStorage.getItem('pa85726549Token') || '{}').token || '' },

        rotuloTipo (t) { return { 1: 'Arquivo', 2: 'Vídeo', 3: 'Link', 4: 'Aviso' }[t] || '' },
        tagTipo (t)    { return { 1: 'info', 2: 'success', 3: 'warning', 4: '' }[t] || '' },

        /*
         * SANEAMENTO DA FASE 2 — o material não tem mais URL pública.
         *
         * Antes, `window.open(m.caminho)` abria a URL pública do arquivo no disco
         * compartilhado — legível por qualquer pessoa com o link. Agora o arquivo vem
         * pela rota do portal, que
         * confere a matrícula do aluno, a publicação e a data de liberação antes de
         * entregar. O navegador recebe um blob.
         */
        baixar (m) {
            if (!m || !m.id || !m.tem_arquivo) return

            this.baixandoId = m.id

            const opt = JSON.parse(JSON.stringify(this.$store.getters.getHeaderAuth))
            opt.responseType = 'blob'

            this.$axios.post(`${this.baseUrl()}/api/portal/material/baixar/${m.id}`, {}, opt)
                .then(resp => {
                    this.baixandoId = null

                    const url = window.URL.createObjectURL(new Blob([resp.data]))
                    const a = document.createElement('a')

                    a.href = url
                    a.download = m.caminho_nome || m.titulo || 'material'
                    document.body.appendChild(a)
                    a.click()
                    a.remove()
                    window.URL.revokeObjectURL(url)

                    // Contabiliza (best-effort; não bloqueia o download).
                    this.$axios.post(`${this.baseUrl()}/api/portal/material/registrar-download/${m.id}`,
                                     {}, this.$store.getters.getHeaderAuth).catch(() => {})
                })
                .catch(e => this.erroDeDownload(e))
        },

        /** O erro chega como blob quando responseType é blob: lê antes de anunciar. */
        erroDeDownload (e) {
            this.baixandoId = null

            const mostrar = (msg) => this.$message.error(msg || 'Não foi possível baixar o arquivo.')
            const d = e && e.response ? e.response.data : null

            if (d instanceof Blob) {
                d.text().then(t => {
                    try { mostrar(JSON.parse(t).erro) } catch (x) { mostrar(null) }
                }).catch(() => mostrar(null))
            } else {
                mostrar(d && d.erro ? d.erro : null)
            }
        },

        load () {
            this.loading = true
            this.$axios.post(`${this.baseUrl()}/api/portal/material/listar`, {}, this.$store.getters.getHeaderAuth)
                .then(r => {
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                        this.materiais = []
                    } else {
                        this.materiais = r.data || []
                    }
                    this.loading = false
                })
                .catch(e => { this.loading = false; this.$store.commit('throwException', e) })
        },

        abrirVideo (m) {
            this.materialAtivo = m
            this.modalVideoVisivel = true
        },
        ehEmbed (s) { return s && s.indexOf('<iframe') !== -1 },
        urlYoutube (s) {
            if (!s) return null
            const reg = /(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]+)/
            const m = s.match(reg)
            return m ? 'https://www.youtube.com/embed/' + m[1] : null
        },

        abrirEnvio (m) {
            this.materialAtivo = m
            this.retornoForm = { caminho: '', caminho_nome: '', caminho_mime: '', caminho_size: null, comentario: '' }
            // Busca retorno existente para mostrar "já enviou..."
            this.$axios.post(`${this.baseUrl()}/api/portal/material/ver/${m.id}`, {}, this.$store.getters.getHeaderAuth)
                .then(r => {
                    if (r.data && r.data.retorno_aluno) {
                        this.materialAtivo.retorno_aluno = r.data.retorno_aluno
                        if (r.data.retorno_aluno.comentario) this.retornoForm.comentario = r.data.retorno_aluno.comentario
                    }
                })
            this.modalEnvioVisivel = true
        },
        beforeUpload (file) {
            this.retornoForm.caminho_nome = file.name
            this.retornoForm.caminho_mime = file.type
            this.retornoForm.caminho_size = file.size
            return true
        },
        onUploadSuccess (res) {
            if (res && res.erro) {
                window.eventBus.$emit('alert', { msg: typeof res.erro === 'string' ? res.erro : res.erro.text, type: 'warning' })
                return
            }
            if (res && res.caminho) {
                this.retornoForm.caminho = res.caminho
                this.retornoForm.caminho_nome = res.caminho_nome
                this.retornoForm.caminho_mime = res.caminho_mime
                this.retornoForm.caminho_size = res.caminho_size
                window.eventBus.$emit('alert', { msg: 'Arquivo enviado.', type: 'success' })
            }
        },
        confirmarEnvio () {
            if (!this.retornoForm.caminho && !this.retornoForm.comentario) {
                window.eventBus.$emit('alert', { msg: 'Anexe um arquivo ou escreva um comentário.', type: 'warning' })
                return
            }
            this.$axios.post(`${this.baseUrl()}/api/portal/material/retorno/${this.materialAtivo.id}`,
                this.retornoForm, this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                    return
                }
                window.eventBus.$emit('alert', { msg: 'Devolução enviada com sucesso!', type: 'success' })
                this.modalEnvioVisivel = false
                this.load()
            }).catch(e => this.$store.commit('throwException', e))
        }
    }
}
</script>

<style scoped>
</style>
